import { SentimentBarGroupsWidgetData } from 'screens/WidgetGenerator/utils/misc';

export const shouldBenchmarkScores = (widgetData: SentimentBarGroupsWidgetData[]): boolean =>
  // If there is at least one group with previous cycle data, we want to benchmark scores.
  widgetData.reduce(
    (hasPreviousCycleDataGroup, group) =>
      hasPreviousCycleDataGroup ||
      group.groupItems.reduce(
        (hasPreviousCycleDataItems, item) => hasPreviousCycleDataItems || Boolean(item.previousCycle),
        false,
      ),
    false,
  );
